require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

/**
 * Async Await to Array
 *
 * @param oOrP objectOrPromise
 * @returns {*}
 */
module.exports = function A2A(oOrP) {
  if (!oOrP) return Promise.resolve([null, oOrP]); // single promise

  if (oOrP.then) {
    return oOrP.then(function (r) {
      return [null, r];
    })["catch"](function (e) {
      return [e, undefined];
    });
  } // array of promises


  if (Array.isArray(oOrP) && oOrP.length && oOrP[0].then) {
    return Promise.all(oOrP).then(function (r) {
      return [null, r];
    })["catch"](function (e) {
      return [e, undefined];
    });
  } // non promise values - error


  if (oOrP instanceof Error) return Promise.resolve([oOrP, undefined]); // non promise values - any other value

  return Promise.resolve([null, oOrP]);
};